import React from "react"
import ReCAPTCHA from "react-google-recaptcha"

const Recaptcha = ({ recaptchaRef }) => {
  return (
    <div className="d-none">
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.GATSBY_RECAPTCHA_KEY}
      />
    </div>
  )
}
export default Recaptcha
